@use '@design/components/custom-scroll/custom-scroll' as *;

.scenarioTableRoot {
  @include custom-scroll-minimal;
  overflow: auto;
  flex: 1 1 0;
  z-index: 1;
}

.tableRoot {
  border-spacing: 0;
  width: 100%;

  --z-index-header-cell: 2;
  --z-index-table-cell: 1;

  th:first-child {
    width: 15%;
  }

  th {
    border-bottom: 1px solid var(--border-default);
  }

  td {
    width: 250px;
    overflow: hidden;
  }

  tr:last-child {
    > td {
      border-bottom: 1px solid var(--border-default);
    }
  }

  &[data-enabled] {
    tbody tr:not([data-accordion-row]):hover {
      background-color: var(--surface-hover);

      td {
        background-color: var(--surface-hover);
      }
    }
  }
}

.tableRoot[data-enabled] tbody tr:not([data-accordion-row]):hover td [aria-haspopup='true'] {
  border-bottom: 1px dashed var(--border-default);
}

.insightsWrapper {
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 0.02rem;
}

.tickerCell {
  display: flex;
  gap: 8px;
}

.wrapperEmptyAssetsState {
  padding: 60px 0;

  [data-empty-insights-description] {
    max-width: 446px;
  }
}
